<template>
  <div>
    <b-form class="row">
      <div class="col-6">
        <b-row class="my-1">
          <div class="col-3">
            <b-form-select
              v-model="email_selected"
              :options="emails"
              value-field="ID"
              text-field="label"
              @change="pickMail"
            ></b-form-select>
          </div>
          <div class="col-9">
            <b-form-input
              required
              type="email"
              v-model="email.to"
            ></b-form-input>
          </div>
        </b-row>
        <b-row class="my-1 align-items-center">
          <div class="col-3 text-right">
            <label style="margin-bottom: 0px">CC :</label>
          </div>
          <div class="col-9">
            <b-form-input type="email" v-model="email.cc"></b-form-input>
          </div>
        </b-row>
        <b-row class="my-1 align-items-center">
          <div class="col-3 text-right">
            <label style="margin-bottom: 0px">CCi :</label>
          </div>
          <div class="col-9">
            <b-form-input type="email" v-model="email.cci"></b-form-input>
          </div>
        </b-row>
        <b-row class="my-1 align-items-center">
          <div class="col-3 text-right">
            <label style="margin-bottom: 0px">Sujet :</label>
          </div>
          <div class="col-9">
            <b-form-input type="text" v-model="email.subject"></b-form-input>
          </div>
        </b-row>
      </div>
      <div class="col-6">
        <b-row>
          <b-col lg="12" class="my-3">
            <b-button v-if="!editMode" @click="editMode = true" size="sm">Éditer le contenu du mail</b-button>
            <b-button v-else @click="editMode = false" size="sm">Cacher le contenu du mail</b-button>
          </b-col>
        </b-row>
        <b-row class="my-1" v-if="editMode">
          <mh-input
            :key="componentKey"
            nolabel
            labelColsLg="0"
            mhClass="col-12"
            field="body"
            :table="email"
          ></mh-input>
        </b-row>
      </div>
      <div class="col-12">
        <b-row>
          <b-col class="text-left mt-3">
            <b-button @click="$emit('close')">Annuler</b-button>
            <b-button @click="send(okButton.params)" class="ml-3">
              <b-spinner v-if="busy" small></b-spinner>
              {{ okButton.label }}
            </b-button>
            <template v-if="appendButtons.length">
              <b-button
                v-for="(button, index) in appendButtons"
                @click="send(button.params)"
                :key="index"
                class="ml-3"
                >{{ button.label }}</b-button
              >
            </template>
          </b-col>
        </b-row>
      </div>
    </b-form>
  </div>
</template>

<script>
import MhInput from "@/components/MhInput.vue";
import mails from "@/services/mails.js";
export default {
  props: {
    okButton: {
      type: Object,
      default: () => {
        return {
          label: "Envoyer",
          params: null,
        };
      },
    },
    appendButtons: {
      type: Array,
      default: () => [],
    },
    body: {
      type: String,
      default: "",
    },
    cc: {
      type: String,
      default: "",
    },
    cci: {
      type: String,
      default: "info@cabinetdegreft.be",
    },
    subject: {
      type: String,
      default: "",
    },
    to: {
      type: String,
      default: "",
    },
    emails_list: Array,
    attached_files: {
      type: Array,
      default: () => [],
    },
    attached_objects: {
      type: Array,
      default: () => [],
    },
  },
  components: {
    MhInput,
  },
  data: () => {
    return {
      email_selected: 0,
      emails: [],
      email: {},
      componentKey: 1,
      busy: false,
      editMode: false,
    };
  },
  beforeMount() {
    this.emails = [...this.$props.emails_list];
    this.emails.forEach((el, index) => {
      el.ID = index;
      if (el.selected) {
        this.email_selected = index;
      }
    });
    this.email = {
      body: {
        value: this.$props.body,
        type: "html",
        label: "Contenu",
      },
      cc: this.$props.cc,
      cci: this.$props.cci,
      subject: this.$props.subject,
      to: this.$props.to,
      attached_files: this.$props.attached_files,
      attached_objects: this.$props.attached_objects,
    };
    this.pickMail(this.email_selected);
  },
  methods: {
    refresh(body) {
      this.email.body.value = body;
      this.componentKey++;
    },
    pickMail(payload) {
      this.email.to = this.emails[payload].mail;
      if (this.emails[payload].body) {
        this.email.body.value = this.emails[payload].body;
      }
      this.$emit("email_change", this.emails[payload]);
    },
    send(params) {
      if (params) {
        this.email.params = params;
      }
      this.busy = true;
      mails.send(this.email).then((response) => {
        if (response.data.success) {
          this.$bvToast.toast(response.data.success, {
            title: `Recuperator`,
            toaster: "b-toaster-top-right",
            variant: "success",
            autoHideDelay: 5000,
            solid: false,
          });
          this.busy = false;
          this.$emit("close");
        } else {
          this.$bvToast.toast(response.data.error, {
            title: `Recuperator`,
            toaster: "b-toaster-top-right",
            variant: "danger",
            autoHideDelay: 5000,
            solid: false,
          });
          this.busy = false;
          this.$emit("close");
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
</style>